import { render } from "./HostPage.vue?vue&type=template&id=0846bc40&scoped=true"
import script from "./HostPage.vue?vue&type=script&lang=js"
export * from "./HostPage.vue?vue&type=script&lang=js"

import "./HostPage.vue?vue&type=style&index=0&id=0846bc40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0846bc40"]])

export default __exports__